import { FALLBACK_PUBLIC_PURCHASE_MOTIONS } from 'pricing-pages-lib/constants/FallbackPublicPurchaseMotions';
import { PURCHASE_MOTIONS } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchPurchaseMotionRequestTypes = createRequestTypes(PURCHASE_MOTIONS);
export const FetchPurchaseMotionActions = createRequestActions(FetchPurchaseMotionRequestTypes);
export const fetchPurchaseMotionData = ({
  getPurchaseMotions,
  isPublic = false
}) => dispatch => {
  dispatch(FetchPurchaseMotionActions.request());
  return getPurchaseMotions().then(data => {
    const {
      locations
    } = data;
    dispatch(FetchPurchaseMotionActions.receive(locations));
  }).catch(error => {
    if (isPublic) {
      dispatch(FetchPurchaseMotionActions.receive(FALLBACK_PUBLIC_PURCHASE_MOTIONS));
    } else {
      dispatch(FetchPurchaseMotionActions.failure(error));
      throw error;
    }
  });
};